import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-reset-modal',
	imports: [],
	templateUrl: './reset-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetModalComponent {}
